import { render, staticRenderFns } from "./InvolvedPropertyForm.vue?vue&type=template&id=3476fd16&"
import script from "./InvolvedPropertyForm.vue?vue&type=script&lang=js&"
export * from "./InvolvedPropertyForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports